var app = angular.module('leonardo');

var ShareStates = function($stateProvider, $urlRouterProvider) {
  // Redirect trailing slash URLs to non-trailing slash for share/document and share/attachment
  $urlRouterProvider.rule(function($injector, $location) {
    var path = $location.path();
    var search = $location.search();
    // Match /share/document/uuid/ or /share/attachment/id/ pattern and redirect without trailing slash
    if (path.match(/^\/share\/(document|attachment)\/[^\/]+\/$/)) {
      var newPath = path.replace(/\/$/, '');
      // Preserve query params
      var queryString = Object.keys(search).map(function(key) {
        return key + '=' + search[key];
      }).join('&');
      return newPath + (queryString ? '?' + queryString : '');
    }
  });
  // Document share - requires authentication, then downloads file
  $stateProvider.state('share-document', {
    url: '/share/document/:url_uuid',
    parent: 'authenticated.layout-minimal',
    params: {
      url_uuid: '',
      view: null
    },
    views: {
      '@authenticated.layout-minimal': {
        templateUrl: 'views/templates/share/download.html',
        controller: 'ShareDocumentController'
      }
    },
    ncyBreadcrumb: {
      skip: true
    }
  });

  // Attachment share - requires authentication, then downloads file
  $stateProvider.state('share-attachment', {
    url: '/share/attachment/:id',
    parent: 'authenticated.layout-minimal',
    params: {
      id: ''
    },
    views: {
      '@authenticated.layout-minimal': {
        templateUrl: 'views/templates/share/download.html',
        controller: 'ShareAttachmentController'
      }
    },
    ncyBreadcrumb: {
      skip: true
    }
  });
};

app.config(['$stateProvider', '$urlRouterProvider', ShareStates]);
